import useNav from "core/hooks/useNav";

import { useQueriesTop, useQueryCampaigns, useQueryFeatured, useQueryLastSeen } from "areas/home/data";


export const useTop = () => {
	const queries = useQueriesTop();

	return {
		day: queries[0],
		week: queries[1]
	};
};

export const useFeatured = () => {
	const query = useQueryFeatured();
	const nav = useNav();

	const subscribe = {
		title: "When a subscription is more than you need",
		description: "Let us make it easy for you.",
		action: "Get Started",
		to: "/auth"
	};

	const features = [
		{
			head: "For Customers",
			title: "Unlock Only What You Want",
			description: <><b>Subly - Read Just What You Want.</b> You can buy just one article without a recurring commitment or cost.</>,
			action: {
				label: "Get Started",
				onClick: () => nav.preserve("/auth")
			}
		},
		{
			head: "For Media Partners",
			title: "More Reader Revenue",
			description: <><b>Get readers enjoying and paying for your hard work.</b> Subscriptions are great for recurring readers but too much commitment for many readers.</>,
			action: {
				label: "Learn More",
				onClick: () => nav.go({ to: "/partners" })
			}
		}
	];

	return { ...query, features, subscribe };

};
export const useLastSeen = useQueryLastSeen;

export const useCampaigns = () => {
	const campaigns = useQueryCampaigns();

	return { ...campaigns };
};